var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dashboard-container" },
    [
      _c("selectCompany", { on: { onSelect: _vm.onSelectCompany } }),
      _c(
        "el-row",
        { staticClass: "panel-group", attrs: { gutter: 40 } },
        [
          _vm.ability(["TransactionSummary", "TransactionSales"])
            ? _c(
                "el-col",
                {
                  staticClass: "card-panel-col",
                  attrs: { xs: 24, sm: 24, lg: 24 },
                },
                [_c("transactionStatusPanel")],
                1
              )
            : _vm._e(),
          _vm.ability(["TransactionSummary", "TransactionSales"])
            ? _c(
                "el-col",
                {
                  staticClass: "card-panel-col",
                  attrs: { xs: 24, sm: 24, lg: 24 },
                },
                [_c("transactionChart")],
                1
              )
            : _vm._e(),
          _vm.ability(["TransactionSummary", "TransactionSales"])
            ? _c(
                "el-col",
                {
                  staticClass: "card-panel-col",
                  attrs: { xs: 24, sm: 24, md: 24 },
                },
                [_c("transactionTable")],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "panel-group", attrs: { gutter: 40 } },
        [
          _c("el-container", { staticClass: "px-3" }, [
            _c("p", { staticClass: "text-h5" }, [_vm._v("機台狀況概覽")]),
          ]),
          _vm.ability(["MvmsList", "MvmsMap"])
            ? _c(
                "el-col",
                {
                  staticClass: "card-panel-col",
                  attrs: { xs: 12, sm: 12, md: 24 },
                },
                [_c("mvmStatusPanel")],
                1
              )
            : _vm._e(),
          _vm.ability(["MvmsList", "MvmsMap"])
            ? _c(
                "el-col",
                {
                  staticClass: "card-panel-col",
                  attrs: { xs: 24, sm: 24, md: 24 },
                },
                [_c("mvmTable")],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "panel-group", attrs: { gutter: 40 } },
        [
          _c("el-container", { staticClass: "px-3" }, [
            _c("p", { staticClass: "text-h5" }, [_vm._v("我的機台")]),
          ]),
          _c(
            "el-col",
            {
              staticClass: "card-panel-col",
              attrs: { xs: 24, sm: 24, md: 24 },
            },
            [_c("myMvmStatusPanel")],
            1
          ),
          _c(
            "el-col",
            {
              staticClass: "card-panel-col",
              attrs: { xs: 24, sm: 24, md: 24 },
            },
            [_c("myMvm")],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }